export default __webpack_public_path__ + "static/media/girl-two.5b3a9f41.jpg";